import { Skeleton } from 'components/Skeleton/Skeleton'
import { ReactComponent as RightArrow } from 'assets/icons/blockyRightArrow16.svg'
import cx from 'classnames'
import Avatar from 'common/Avatar/Avatar'
import { Button } from 'components/Button/Button'
import { useRequestReadAccess } from 'hooks/queries/articles/useRequestReadAccess'
import Styles from '../CardViewComponent.module.scss'
import { CardViewProps, SkeletonCardProps } from '../cardViewTypes'
import { getDetailsFromBackground } from '../utils/getDetailsFromBackground'
import { InteractionButtons } from './components/InteractionButtons'

export const ExpandedSmallAvatarCardView = (props: CardViewProps) => {
  const {
    disabled,
    selected,
    commentSelected,
    tasks,
    comments,
    mentionSubject,
    subtitle,
    cardStyle,
    articleId,
    loading,
    isError,
  } = props
  const { font, background } = cardStyle
  const details = getDetailsFromBackground(background)
  const [requestReadAccess, requestingAccess] = useRequestReadAccess()
  const backgroundColor = isError ? '#6D778B' : background

  if (loading) return <ExpandedSmallAvatarCardSkeleton selected={selected} />

  const viewButton = () => {
    if (isError && articleId)
      return (
        <Button
          className={Styles.requestAccessButton}
          isDisabled={requestingAccess}
          variant="tertiary"
          endIcon={RightArrow}
          onPress={() => requestReadAccess(articleId)}
        >
          Request Access
        </Button>
      )
    return null
  }

  return (
    <div
      data-test-id="cardViewComponent"
      style={{ background: backgroundColor }}
      className={`${cx(Styles.cardView, Styles.expandedSmallAvatar, {
        [Styles.selected]: selected,
        [Styles.commentSelected]: commentSelected,
        [Styles.restricted]: isError,
        [Styles.whiteText]: details.darkBackground || isError,
        [Styles.boxShadow]: details.includeBoxShadow && !isError,
      })}`}
    >
      <div className={Styles.cardViewRight}>
        <Avatar className={Styles.avatar} size={40} {...mentionSubject.avatar} />
        <div className={Styles.titleContainer}>
          <p className={Styles.title} style={{ fontFamily: font }}>
            {mentionSubject.title}
          </p>
          <p className={Styles.subtitle} style={{ fontFamily: font }}>
            {subtitle}
          </p>
        </div>
      </div>
      {viewButton()}
      <InteractionButtons disabled={disabled} tasks={tasks} comments={comments} />
    </div>
  )
}

const ExpandedSmallAvatarCardSkeleton = ({ selected }: SkeletonCardProps) => {
  return (
    <div
      data-test-id="cardViewComponent"
      className={`${cx(Styles.cardView, Styles.expandedSmallAvatar, Styles.loading, {
        [Styles.selected]: selected,
      })}`}
    >
      <div className={Styles.cardViewRight}>
        <Avatar className={Styles.avatar} size={40} />
        <div className={Styles.titleContainer}>
          <Skeleton className={Styles.title} paragraph={false} title={false} />
          <Skeleton className={Styles.subtitle} paragraph={false} title={false} />
        </div>
      </div>
      <Skeleton className={Styles.buttonSkeleton} paragraph={false} title={false} />
    </div>
  )
}
